/** Native dialog viewer for draft service covers. */
class MxbServiceCover extends HTMLElement {
  #controller;
  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('[data-cover-open]')) {
        if (!dialog.open) dialog.showModal();
        return;
      }
      if (target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    }, { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.querySelector('dialog[open]')?.close();
    this.#controller?.abort();
  }
}
if (!customElements.get('mxb-service-cover')) customElements.define('mxb-service-cover', MxbServiceCover);
